module.exports = __webpack_public_path__ + "media/mural.6f401e96.mp3";